import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="department";
export function selectAll(){
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
  })
}

export function selectOne(parameter) {
  return axios({
    url: `/ws/${moduleName}/${parameter}`,
    method: 'get'
  })
}


export function queryResourceTree(){
  return axios({
    url: `/ws/${moduleName}/queryResourceTree`,
    method: 'get'
  })
}

export function insert(parameter) {
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}

export function update(parameter){
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}



export function selectDepByCompanyId(parameter){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectDepByCompanyId/${parameter}`,
    method: 'get'
  })
}



export function selectDepDataByCompanyId(parameter,tableName){
  console.log("id:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectDepDataByCompanyId/${parameter}/${tableName}`,
    method: 'get'
  })
}


export function selectCompanyInfo(){
  return axios({
    url: `/ws/${moduleName}/selectCompanyInfo`,
    method: 'get'
  })
}


export function selectDealCompanyInfo(){
  return axios({
    url: `/ws/${moduleName}/selectDealCompanyInfo`,
    method: 'get'
  })
}

export function selectpursuitsCompanyInfo(){
  return axios({
    url: `/ws/${moduleName}/selectpursuitsCompanyInfo`,
    method: 'get'
  })
}


export function deleteObj(ids) {
  return axios({
    url:`/ws/${moduleName}`,
    method:'delete',
    params: ids,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export default {
  selectDealCompanyInfo,
  selectpursuitsCompanyInfo,
  selectAll,
  selectOne,
  selectDepByCompanyId,
  selectDepDataByCompanyId,
  selectCompanyInfo,
  queryResourceTree,
  save:insert,
  update,
  delete:deleteObj,
}